export default function getNormalizedFullAddress(fullAddressValue) {
    const { value } = fullAddressValue;
    const normalizedValue = String(value);
    return {
        type: 'full-address',
        value: normalizedValue,
    };
}
